module.exports = __webpack_public_path__ + "Sea Dune-3f616a04.png";